import { lazySearchSuggestions } from 'owa-recipient-suggestions';
import postProcessSuggestionsResult from './postProcessSuggestionsResult';
import processResponseResults from './processResponseResults';
import {
    populateFeedbackStateNetwork,
    updateFeedbackStateNetwork,
} from '../../utils/populateFeedbackState';
import setIsSearching from '../setIsSearching';
import updateCurrentRenderedQueryString from '../updateCurrentRenderedQueryString';
import getTransactionIdFromResponse from 'owa-recipient-common/lib/utils/getTransactionIdFromResponse';
import { now } from 'owa-datetime';
import { getGuid } from 'owa-guid';
import { FindResultType } from 'owa-recipient-types/lib/types/FindControlViewState';
import addTransactionComplete from 'owa-recipient-common/lib/utils/addTransactionComplete';
import { action } from 'satcheljs/lib/legacy';
import FindControlViewState, {
    DirectorySearchType,
} from 'owa-recipient-types/lib/types/FindControlViewState';

const MAX_ENTRIES_DIRECTORY = 20;

export default action('autoSearchDirectory')(async function autoSearchDirectory(
    recipientWell: FindControlViewState,
    queryString: string,
    resolveIfSingle?: boolean
): Promise<void> {
    let transactionStartTime = now();
    const clientRequestId = getGuid();
    // Record the beginning of the live call
    // in case the live call hangs and the user submits feedback before it returns
    populateFeedbackStateNetwork(
        recipientWell,
        transactionStartTime,
        clientRequestId,
        true /*directory*/
    );
    let response = await lazySearchSuggestions
        .import()
        .then(getSuggestions =>
            getSuggestions(
                queryString,
                true /* searchDirectory*/,
                clientRequestId,
                recipientWell.findPeopleFeedbackManager
            )
        );
    setIsSearching(recipientWell, false);
    let sameQueryString = recipientWell.queryString.trim() == queryString;

    if (sameQueryString) {
        let maxFindResultShown = MAX_ENTRIES_DIRECTORY;
        updateCurrentRenderedQueryString(recipientWell, queryString);
        processResponseResults(
            recipientWell.findResultSet,
            response,
            false /*appendResults*/,
            maxFindResultShown,
            true /*returnMaskedRecipients*/
        );

        updateFeedbackStateNetwork(recipientWell, true /*directory*/, response);

        addTransactionComplete(
            recipientWell,
            transactionStartTime,
            getTransactionIdFromResponse(response)
        );
        recipientWell.directorySearchType = DirectorySearchType.Auto;
        /* manually trigger rerender if the response has 0 elements */
        if (recipientWell.findResultSet.length == 0) {
            recipientWell.findResultSet = [];
        }
        postProcessSuggestionsResult(
            recipientWell,
            FindResultType.SearchDirectory,
            resolveIfSingle
        );
    }
});
